import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  payments: [],
  paymentsDue: [],
  currentPayment: null,
  loading: false,
  error: null,
  statistics: {
    totalPaid: 0,
    totalDue: 0,
    overdue: 0
  },
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  filters: {
    search: '',
    status: 'all',
    dateRange: null
  }
}

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setPayments: (state, action) => {
      state.payments = action.payload
    },
    setPaymentsDue: (state, action) => {
      state.paymentsDue = action.payload
    },
    setCurrentPayment: (state, action) => {
      state.currentPayment = action.payload
    },
    addPayment: (state, action) => {
      state.payments.push(action.payload)
    },
    updatePayment: (state, action) => {
      const index = state.payments.findIndex(payment => payment.id === action.payload.id)
      if (index !== -1) {
        state.payments[index] = action.payload
      }
    },
    setStatistics: (state, action) => {
      state.statistics = action.payload
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload }
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    clearError: (state) => {
      state.error = null
    }
  }
})

export const {
  setLoading,
  setError,
  setPayments,
  setPaymentsDue,
  setCurrentPayment,
  addPayment,
  updatePayment,
  setStatistics,
  setPagination,
  setFilters,
  clearError
} = paymentsSlice.actions

export default paymentsSlice.reducer